import {gql} from '@apollo/client';

export const userInviteMutations = {
    INVITE_MULTIPLE_USERS_TO_SCOPE_BY_EMAIL: gql`
        mutation InviteMultipleUsersToScopeByEmail($request: InviteMultipleUserToScopeByEmailRequestInput!) {
            inviteMultipleUsersToScopeByEmail(request: $request) {
                data
                message
                statusCode
                success
            }
        }
    `,
    VERIFY_USER_INVITATION: gql`
        mutation VerifyUserInvitation($token: String!) {
            verifyUserInvitation(token: $token) {
                data
                message
                statusCode
                success
            }
        }
    `,

    ADD_USER_IF_NOT_EXIST_AFTER_INVITE: gql`
        mutation AddUserIfNotExistAfterInvite($token: String!, $input: AddUserViewModelInput!) {
            addUserIfNotExistAfterInvite(token: $token, input: $input) {
                data
                message
                statusCode
                success
            }
        }
    `,
};
